import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { HistoricalDataService } from 'src/app/services/historical-data.service';
import { AccessYourSuperService } from 'src/app/services/access-your-super.service';

@Injectable()
export class AccessYourSuperStartComponentEffects {
  constructor(private store: Store<any>,
    private actions$: Actions,
    private router: Router,
    private service: AccessYourSuperService) {
  }

  getApplicationList$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestAction),
    switchMap((action: any) => this.service.getApplicationList(action.accountId)),
    map((data: any) => {
      return ActionsList.ResponseAction({ payload: data.data });
    })
  ));
}
